import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { types } from '../actions/plansActions';
import { PlanModel } from '../models/PlanModel';

export default function plansReducer(state = Immutable(initialState.plans), action) {
   switch (action.type) {
    case types.GET_PLANS:
      return state.merge({ fetching: true, error: null });
    case types.GET_PLANS_SUCCESS:
      return state.merge({
        fetching: false,
        error: null,
        data: action.plans.map(p => new PlanModel(
          p.id,
          p.name,
          p.description,
          p.price,
          p.validity,
          p.freeMinutesPerDay,
          p.freeMinutesPerPeriod,
          p.tenant,
          p.bikeTypeId,
          p.excludeInactiveMonths
        )),
      });
    case types.GET_TENANT_BIKE_TYPES:
      return state.merge({
        bikeTypesFetchingByTenant: Object.assign({}, state.bikeTypesFetchingByTenant, { [action.tenant]: true }),
        bikeTypesErrorByTenant: Object.assign({}, state.bikeTypesErrorByTenant, { [action.tenant]: null }),
      });
    case types.GET_TENANT_BIKE_TYPES_SUCCESS:
      return state.merge({
        bikeTypesByTenant: Object.assign({}, state.bikeTypesByTenant, { [action.tenant]: action.bikeTypes }),
        bikeTypesFetchingByTenant: Object.assign({}, state.bikeTypesFetchingByTenant, { [action.tenant]: false }),
        bikeTypesErrorByTenant: Object.assign({}, state.bikeTypesErrorByTenant, { [action.tenant]: null }),
      });
    case types.GET_TENANT_BIKE_TYPES_FAILURE:
      return state.merge({
        bikeTypesFetchingByTenant: Object.assign({}, state.bikeTypesFetchingByTenant, { [action.tenant]: false }),
        bikeTypesErrorByTenant: Object.assign({}, state.bikeTypesErrorByTenant, { [action.tenant]: true }),
      });
    case types.GET_PLANS_FAILURE:
      return state.merge({ fetching: false, error: true });
    default:
      return state;
  }
}
